module.exports = __webpack_public_path__ + "static/leads1-508bd509c77db70a180d714d7d1eb5cd.png";